import enUS from './en-US';
import zhCN from './zh-CN';

export const DEFAULT_LOCALE = 'en-US';

const messagesMap: Record<string, Record<string, string>> = {
  'en-US': enUS,
  'zh-CN': zhCN,
};

export const getLocaleMessages = (locale: string = DEFAULT_LOCALE) =>
  messagesMap[locale] || messagesMap[DEFAULT_LOCALE];
